import { buttonStyle } from 'components/buttons/buttonStyle';
import { Button } from 'components/ui/button';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

// Store
import { RootState } from 'store/reducers';
import { clearDebtReminderInvoices } from 'store/reducers/invoices';

// Hooks
import { useDebtReminderModal } from 'components/modals/invoices/DebtReminderModal';

export const DebtReminderButton = () => {
    const dispatch = useDispatch();
    const selectedDebtReminderInvoiceIds = useSelector(
        (state: RootState) => state.invoices.selectedDebtReminderInvoiceIds
    );
    const { invoicePdfLanguage, selectedInvoice } = useSelector((state: RootState) => {
        if (selectedDebtReminderInvoiceIds.length === 1) {
            const invoiceId = selectedDebtReminderInvoiceIds[0];
            const invoice = state.invoices.selectedInvoices[invoiceId];
            return {
                invoicePdfLanguage: invoice?.invoicePdfLanguage,
                selectedInvoice: invoice,
            };
        }
        return {
            invoicePdfLanguage: undefined,
            selectedInvoice: undefined,
        };
    });

    const isEnabled = selectedDebtReminderInvoiceIds.length === 1;
    const { openDebtReminderModal } = useDebtReminderModal(
        isEnabled ? [selectedDebtReminderInvoiceIds[0]] : undefined,
        selectedInvoice,
        invoicePdfLanguage
    );

    return (
        <div className="flex flex-row justify-end gap-2">
            <Button
                {...buttonStyle({
                    variant: isEnabled ? 'contained' : 'outlined',
                    color: isEnabled ? 'secondary' : undefined,
                    size: 'small',
                })}
                disabled={!isEnabled}
                onClick={() => {
                    void openDebtReminderModal();
                    // The ticks have done their job the moment the modal has the ids. Clearing
                    // belongs here and not inside the modal, which is opened from the search peek
                    // too — from there it has no business emptying a list the reader was building.
                    dispatch(clearDebtReminderInvoices());
                }}
            >
                <FormattedMessage id="invoices.table-view.debt-reminder-button" />
            </Button>
        </div>
    );
};
